import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { BasicService } from './basic.service';

@Injectable({
  providedIn: 'root'
})
export class DocumentMappingService {

  constructor(private http: HttpClient, private basicService: BasicService) { }

  private authHeaders(json = true): any {
    const headers: any = {};
    if (json) {
      headers['Content-Type'] = 'application/json';
    }
    const userData = this.basicService.user_data || this.basicService.getItem('user_data');
    if (userData && (userData.loginToken || userData.apiKey)) {
      headers['Authorization'] = 'Bearer ' + (userData.loginToken || userData.apiKey);
    }
    return headers;
  }

  searchDocumentsBySupplierId(supplierId: string) {
    return this.http.post<any>(
      environment.auth_url + '/api/searchDocumentsBySupplierId',
      { supplierId },
      { headers: this.authHeaders() }
    );
  }

  getSupplierMappingDashboard(
    startId: number = 0,
    searchValue: string = '',
    limit: number = 10,
    status: string = ''
  ) {
    return this.http.post<any>(
      environment.auth_url + '/api/getSupplierMappingDashboard',
      {
        start_id: startId,
        search_value: searchValue || '',
        limit,
        status: status || ''
      },
      { headers: this.authHeaders() }
    );
  }

  getSupplierMappingAttempts(supplierId: string) {
    return this.http.post<any>(
      environment.auth_url + '/api/getSupplierMappingAttempts',
      { supplierId },
      { headers: this.authHeaders() }
    );
  }

  publishDocumentMapping(documentId: number) {
    return this.http.post<any>(
      environment.auth_url + '/api/publishDocumentMapping',
      { documentId },
      { headers: this.authHeaders() }
    );
  }

  retryDocumentMapping(documentId: number) {
    return this.http.post<any>(
      environment.auth_url + '/api/retryDocumentMapping',
      { documentId },
      { headers: this.authHeaders() }
    );
  }

  getAllDocuments(
    startId: number = 0,
    searchValue: string = '',
    limit: number = 10,
    status: string | number | null = null
  ) {
    const body: any = {
      start_id: startId,
      search_value: searchValue,
      limit,
      status: status !== null && status !== undefined && String(status).trim() !== '' ? status : ''
    };
    return this.http.post<any>(
      environment.auth_url + '/api/getAllDocuments',
      body,
      { headers: this.authHeaders() }
    );
  }

  uploadDocument(file: File, supplierId: string, userId: number) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('supplierId', supplierId);
    formData.append('userId', userId.toString());
    return this.http.post<any>(
      environment.auth_url + '/api/uploadDocument',
      formData,
      { headers: this.authHeaders(false) }
    );
  }

  getExtractedData(documentId: number) {
    return this.http.post<any>(
      environment.auth_url + '/api/getExtractedData',
      { documentId },
      { headers: this.authHeaders() }
    );
  }

  getSheetPreview(documentId: number) {
    return this.http.get<any>(
      environment.auth_url + '/api/getDocumentSheetPreview/' + documentId,
      { headers: this.authHeaders(false) }
    );
  }

  saveFieldMapping(documentId: number, mappingData: any) {
    return this.http.post<any>(
      environment.auth_url + '/api/saveFieldMapping',
      { documentId, ...mappingData },
      { headers: this.authHeaders() }
    );
  }

  deleteDocument(documentId: number) {
    return this.http.post<any>(
      environment.auth_url + '/api/deleteDocument',
      { documentId },
      { headers: this.authHeaders() }
    );
  }

  getDocumentFileBlob(documentId: number) {
    return this.http.get(
      environment.auth_url + '/api/getDocumentFile/' + documentId,
      { headers: this.authHeaders(false), responseType: 'blob' }
    );
  }
}
